module.exports = __webpack_public_path__ + "front/img/logo-3.407772f1.png";